import { Compass, TriangleAlert } from 'lucide-react';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router';
import { Page } from '../components/layout/Page';
import { Button } from '../components/ui/Button';
import { EmptyState } from '../components/ui/EmptyState';
import { errorMessage } from '../lib/api';

/** Route `errorElement`: a crash in one page shows this instead of a blank screen. */
export function RouteError() {
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundPage />;
  console.error(error);
  return (
    <Page>
      <EmptyState
        icon={TriangleAlert}
        title="Something went wrong on this page"
        description={isRouteErrorResponse(error) ? error.statusText : errorMessage(error)}
        action={
          <Button variant="primary" onClick={() => window.location.reload()}>
            Reload
          </Button>
        }
      />
    </Page>
  );
}

export function NotFoundPage() {
  return (
    <Page>
      <EmptyState
        icon={Compass}
        title="Page not found"
        description="The page you are looking for doesn't exist or was moved."
        action={
          <Link to="/" className="text-[13px] font-medium text-ember-600 hover:underline">
            Back to dashboard
          </Link>
        }
      />
    </Page>
  );
}
